export enum MessageCodes {
  Success = -1,
  UnknownError = 0,
  AccessDenied = 32,
  SelectedEntityHasNotSubmittedDataOrIsNotRequired = 141,
  ObjectDownloadFailed = 142,
}
